import { addDays, addMonths, endOfMonth, startOfMonth, subMonths } from "date-fns";
import subDays from "date-fns/subDays";
import React from "react";
import { RCCDateTimePickerRange } from "react-common-components";
import IDateTimePickerRange from "react-common-components/dist/components/DateTimePickerRange/interface";
import { useTranslation } from "src/context/Translations/context";

const DateTimePickerRange: React.FC<IDateTimePickerRange> = ({
	...rest
}) => {
	const {translate ,currentLanguage} = useTranslation();

	const defaultPeriods = [
		{ name:translate("Hoje") , initialDate: new Date(), endDate: new Date() },
		{ name:translate("Ontem") , initialDate: subDays(new Date(),1), endDate:subDays(new Date(),1) },
		{ name:translate("Últimos 7 dias") , initialDate: subDays(new Date(),7), endDate: new Date() },
		{ name:translate("Últimos 30 dias") , initialDate: subDays(new Date(),30), endDate: new Date() },
		{ name:translate("Próximos 30 dias") , initialDate: new Date(), endDate: addDays(new Date(),30) },
		{ name:translate("Mês atual") , initialDate:startOfMonth(new Date()), endDate: endOfMonth(new Date()) },
		{ name:translate("Mês passado") , initialDate:startOfMonth(subMonths(new Date(),1)), endDate: endOfMonth(subMonths(new Date(),1)) },
		{ name:translate("Próximo mês") , initialDate:startOfMonth(addMonths(new Date(),1)), endDate: endOfMonth(addMonths(new Date(),1)) }
	];

	return(
		<RCCDateTimePickerRange 
			locale={currentLanguage}
			periods={defaultPeriods}
			{...rest}
		/>
	);
};

export default DateTimePickerRange;
